import React, { useEffect, useState } from "react";
import ReactDom from "react-dom";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export var Overlay = function Overlay(_ref) {
  var visible = _ref.visible,
    onClick = _ref.onClick;
  return /*#__PURE__*/_jsx("div", {
    onClick: onClick,
    className: "fixed z-30 inset-0 bg-gray-700 bg-opacity-60 overflow-y-auto h-full w-full" + (visible ? " block" : " hidden"),
    id: "my-modal"
  });
};
var SideModal = function SideModal(_ref2) {
  var className = _ref2.className,
    visible = _ref2.visible,
    onClick = _ref2.onClick,
    children = _ref2.children,
    onlyMobile = _ref2.onlyMobile,
    survey = _ref2.survey,
    _ref2$config = _ref2.config,
    config = _ref2$config === void 0 ? {} : _ref2$config;
  return /*#__PURE__*/ReactDom.createPortal(/*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Overlay, {
      visible: visible,
      onClick: onClick
    }), visible && /*#__PURE__*/_jsx("div", {
      className: " fixed h-screen right-0 ".concat(survey === true ? "lg:top-[60%] top-[48%]" : "", "  bottom-0 ").concat(onlyMobile ? "lg:hidden" : "").concat(className ? className : "w-full lg:w-[25%]", "  ml-auto overflow-y-visible z-[999999] \""),
      children: /*#__PURE__*/_jsx("div", {
        className: " ".concat(className ? "" : "py-4", " ").concat(config !== null && config !== void 0 && config.darkMode ? "bg-black text-white" : "bg-white", " shadow-sm h-full rounded-t-2xl ").concat(survey === true ? "lg:rounded-t-2xl" : "", "   lg:rounded-none"),
        children: children
      })
    })]
  }), document.getElementById("sideModal"));
};
export default SideModal;